<template>
  <div class="table_box">
    <div class="top_nav_box" :class="thaderClass">
      <ul v-for="item in titleList" :key="item.id">
        <li>{{ item.name }}</li>
      </ul>
    </div>
    <div :class="index % 2 == 0 ? 'item_box' : 'active_item_box'" v-for="(item, index) in tableList" :key="item.id">
      <ul>
        <li>{{ item.stockCode }}</li>
        <li>{{ item.stockName }}</li>
        <li>{{ item.addHold }}</li>
        <li :style="item.addHoldMarketCap > 0 ? 'color: #F54F4C' : 'color: #5CBC7C'">{{ item.addHoldMarketCap }}</li>
        <li>{{ item.swl1 }}</li>
        <li><trend-chart :id="`trend-${chartId}-${index}`" :chart-data="Array.from(item.addHoldList, ({addHoldMarketCap})=>addHoldMarketCap)" :yMax="Math.max(...sumList)" :yMin="Math.min(...sumList)" /></li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, watch } from 'vue'
import trendChart from './trend-chart.vue'
export default defineComponent({
  props: {
    tableList: {
      type: Array,
      default: []
    },
    chartId: {
      type: String,
      default: ''
    },
    thaderClass: {
      type: String,
      default: ''
    }
  },
  components: {
    trendChart
  },
  setup(props) {
    const dataMap = reactive({
      titleList: [
        {
          id: 1,
          name: '股票代码'
        },
        {
          id: 2,
          name: '股票名称'
        },
        {
          id: 3,
          name: '持股数量变动(万股)'
        },
        {
          id: 4,
          name: '净买入(亿元)'
        },
        {
          id: 5,
          name: '申万一级'
        },
        {
          id: 6,
          name: '趋势图'
        }
      ],
      sumList: 0
    })
    let sum:any = []
    watch(props, (newName, oldName) => {
      props.tableList.map((item:any)=>{
        sum.push(...(item.addHoldList.map((inner:any)=>Number(inner.addHoldMarketCap))))
      })
      dataMap.sumList = sum
    });
    return {
      ...toRefs(dataMap)
    }
  }
})

</script>
<style scoped lang="scss">
.table_box {
  // width: 926px;
  margin: 38px auto 38px auto;
  border: 1px solid #E8E8E8;
  > .top_nav_box {
    width: 100%;
    height: 47px;
    background: #F2F6FF;
    display: flex;
    align-items: center;
    &.redBg{
      color: #fff;
      background: #A61C1A;
    }
    &.greenBg{
      color: #fff;
      background: #21740C;
    }
    > ul {
      font-size: 16px;
      height: 100%;
      border-right: 1px solid #E8E8E8;
      &:first-child {
        // width: 147px;
          width: 14%;
      }
      &:nth-child(2) {
        // width: 183px;
        width: 19%;
      }
      &:nth-child(3) {
        // width: 151px;
        width: 17%;
      }
      &:nth-child(4) {
        // width: 151px;
        width: 17%;
      }
      &:nth-child(5) {
        // width: 151px;
        width: 17%;
      }
      &:last-child {
        // width: 138px;
        width: 15%;
        border-right: none;
      }
      > li {
        text-align: center;
        margin-top: 13px;
      }
    }
  }
  > .item_box {
    width: 100%;
    //height: 35px;
    background: #FFFFFF;
    > ul {
      font-size: 16px;
      display: flex;
      align-items: center;
      height: 100%;
      > li {
        font-size: 16px;
        border-right: 1px solid #E8E8E8;
        padding-top: 8px;
        &:first-child {
          // width: 147px;
          width: 14%;
          text-align: center;
        }
        &:nth-child(2) {
          // width: 183px;
          width: 19%;
          text-align: center;
          //text-align: right;
          //padding-right: 37px;
        }
        &:nth-child(3) {
          // width: 151px;
          width: 17%;
          text-align: right;
          padding-right: 28px;
        }
        &:nth-child(4) {
          // width: 151px;
          width: 17%;
          text-align: right;
          padding-right: 40px;
        }
        &:nth-child(5) {
          // width: 151px;
          width: 17%;
          text-align: center;
          //text-align: right;
          //padding-right: 28px;
        }
        &:last-child {
          // width: 138px;
          width: 15%;
          border-right: none;
        }
      }
    }
  }
  >  .active_item_box {
    width: 100%;
    //height: 35px;
    background: #F4F7FA;
    > ul {
      font-size: 16px;
      display: flex;
      align-items: center;
      height: 100%;
      > li {
        border-right: 1px solid #E8E8E8;
        padding-top: 8px;
        &:first-child {
          // width: 147px;
          width: 14%;
          text-align: center;
        }
        &:nth-child(2) {
          // width: 183px;
          width: 19%;
          text-align: center;
          //text-align: right;
          //padding-right: 37px;
        }
        &:nth-child(3) {
          // width: 151px;
          width: 17%;
          text-align: right;
          padding-right: 28px;
        }
        &:nth-child(4) {
          // width: 151px;
          width: 17%;
          text-align: right;
          padding-right: 40px;
        }
        &:nth-child(5) {
          // width: 151px;
          width: 17%;
          text-align: center;
          //text-align: right;
          //padding-right: 28px;
        }
        &:last-child {
          // width: 138px;
          width: 15%;
          border-right: none;
        }
      }
    }
  }
}
</style>
